module.exports = __webpack_public_path__ + "658ed4157408d41552a7c0e9e23bad97.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/sjf-icn-clr.png
// module id = 1772
// module chunks = 0